import { Map, List, fromJS } from 'immutable'

export function batchCreatePeopleLoading(state = false, action) {
  switch (action.type) {
    case 'PEOPLE_BATCH_CREATE_LOADING':
      return action.loading || false
    case 'PEOPLE_BATCH_CREATE_SUCCESS':
    case 'PEOPLE_BATCH_CREATE_ERROR':
      return false
    default:
      return state
  }
}

export function batchCreatePeopleErrorMessage(state = false, action) {
  switch (action.type) {
    case 'PEOPLE_BATCH_CREATE_SUCCESS':
      return false
    case 'PEOPLE_BATCH_CREATE_ERROR':
      return action.message
    default:
      return state
  }
}
